import { render } from "./InputEmailModal.vue?vue&type=template&id=013d34b4&ts=true"
import script from "./InputEmailModal.vue?vue&type=script&lang=ts"
export * from "./InputEmailModal.vue?vue&type=script&lang=ts"

import exportComponent from "G:\\wamp\\www\\vahanwale\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__